import { useRecoilState, useRecoilValue } from 'recoil';
import { addressState, proxyState, web3Service } from 'store/web3';
import { useEffect, useState } from 'react';
import { MaxUint } from 'constants/variables';
import { transactionStatus } from 'store/transaction';

export function useWeb3Service() {
  const service = useRecoilValue(web3Service);
  return service;
}

export function useAddress() {
  const service = useRecoilValue(web3Service);
  const [address, setAddress] = useRecoilState(addressState);
  const setter = async (newAddress: string) => {
    service.setAddress(newAddress);
    setAddress(newAddress);
    await service.initProxyAddress();
  };
  return [address, setter];
}

// export function useProxy() {
//   const service = useRecoilValue(web3Service);
//   const [proxy, setProxy] = useRecoilState(proxyState);
//   const setter = (newProxy: string) => {
//     service.setProxy(newProxy);
//     setProxy(newProxy);
//   };
//   return [proxy, setter];
// }

/*
 * contract: address of token
 * owner: walletAddress
 * spender: proxy
 * */
export function useApprove(
  abi: any,
  token: string | undefined,
  owner: string,
  spender: string,
) {
  const [approve, setApprove] = useState<boolean>(false);
  const service = useWeb3Service();
  const [transaction, setTransaction] = useRecoilState(transactionStatus);
  const [loading, setLoading] = useState<boolean>(true);
  //console.log('useApprove');

  const checkApprove = async (): Promise<boolean> => {
    if (!owner || !spender || !token || !service.appContext.address[token]) {
      return false;
    }
    try {
      setLoading(true);
      const checkContract = service.initContract(
        abi,
        service.appContext.address[token],
      );
      const approve = await checkContract.methods
        .allowance(owner, spender)
        .call();

      if (!approve) {
        return false;
      }
      return approve > 0;
    } catch (err) {
      //console.log(err);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (): Promise<void> => {
    if (!token) return;
    try {
      const contract = service.initContract(
        abi,
        service.appContext.address[token],
      );
      setTransaction({ ...transaction, loading: true });
      await contract.methods
        .approve(spender, MaxUint)
        .send({
          from: owner,
        })
        .on('error', error => {
          setTransaction({ ...transaction, loading: false, error: error });
        })
        .on('receipt', function (receipt) {
          setTransaction({
            loading: false,
            error: null,
            tx: receipt.transactionHash,
          });
          setApprove(true);
        });
    } catch (err) {
      // if (!owner || !spender || !token) return
    }
  };

  useEffect(() => {
    checkApprove().then(setApprove);
  }, [abi, token, owner, spender]);

  return [approve, handleApprove, loading] as const;
}
